import {AuthApiService} from "../auth/auth-api.service";
import {Injectable} from "@angular/core";
import {CustomerInstanceVenueData} from "../customer-instance-venue/customer-instance-venue.data";
import {CustomerInstanceVenueViewData} from "./customer-instance-venue-view.data";
import {CustomerInstanceVenueSearchData} from "./customer-instance-venue-search.data";
import {VenueCompany} from "./venue-company/venue-company.data";
import {VenueAddress} from "./venue-address/venue-address.data";
import {VenueContactData} from "./venue-contact/venue-contact.data";
import {VenueServices} from "./venue-services/venue-services.data";
import {VenuePlanData} from "./venue-plan/venue-plan.data";
import {VenueCardVerification} from "./venue-card-verification/venue-card-verification.data";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class CustomerInstanceVenueService {

    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async getCustomerInstanceVenue(venueId: string): Promise<CustomerInstanceVenueViewData> {
        return firstValueFrom(this.http.get<CustomerInstanceVenueViewData>("/fonzie/customer-instance-venue/" + venueId, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async createCustomerInstanceVenue(customerInstanceVenue: CustomerInstanceVenueData): Promise<CustomerInstanceVenueData> {
        return firstValueFrom(this.http.post<CustomerInstanceVenueData>("/fonzie/customer-instance-venue", customerInstanceVenue, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async updateCustomerInstanceVenue(customerInstanceVenue: CustomerInstanceVenueData): Promise<CustomerInstanceVenueData> {
        return firstValueFrom(this.http.put<CustomerInstanceVenueData>("/fonzie/customer-instance-venue", customerInstanceVenue, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerInstanceVenues(): Promise<CustomerInstanceVenueSearchData[]> {
        return firstValueFrom(this.http.get<CustomerInstanceVenueSearchData[]>("/fonzie/customer-instance-venues", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async assignInstanceToCustomerInstanceVenue(venueId: string, instanceId: string): Promise<void> {
        return firstValueFrom(this.http.put<void>("/fonzie/customer-instance-venue/" + venueId + "/assign-instance/" + instanceId, {}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async newId(): Promise<string> {
        return firstValueFrom(this.http.get("/fonzie/new-id", {
            headers: this.auth.getHttpHeaderOptions(),
            responseType: "text"
        }));
    }

    async saveVenueCompany(venueId: string, company: VenueCompany): Promise<VenueCompany> {
        return firstValueFrom(this.http.post<VenueCompany>("/fonzie/customer-instance-venue/" + venueId + "/venue-company", company, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async saveVenueAddress(venueId: string, address: VenueAddress): Promise<VenueAddress> {
        return firstValueFrom(this.http.post<VenueAddress>("/fonzie/customer-instance-venue/" + venueId + "/address", address, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async saveVenueContact(venueId: string, contact: VenueContactData): Promise<VenueContactData> {
        return firstValueFrom(this.http.post<VenueContactData>("/fonzie/customer-instance-venue/" + venueId + "/venue-contacts", contact, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async saveVenueCardVerification(venueId: string, cardVerification: VenueCardVerification): Promise<VenueCardVerification> {
        return firstValueFrom(this.http.post<VenueCardVerification>("/fonzie/customer-instance-venue/" + venueId + "/card-verification", cardVerification, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async saveVenueServices(venueId: string, services: VenueServices): Promise<VenueServices> {
        return firstValueFrom(this.http.post<VenueServices>("/fonzie/customer-instance-venue/" + venueId + "/venue-services", services, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async updatePlan(venueId: string, plan: VenuePlanData): Promise<VenuePlanData> {
        return firstValueFrom(this.http.post<VenuePlanData>("/fonzie/customer-instance-venue/" + venueId + "/plan", plan, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async updatePlanManagement(venueId: string, plan: VenuePlanData): Promise<VenuePlanData> {
        return firstValueFrom(this.http.post<VenuePlanData>("/fonzie/customer-instance-venue/" + venueId + "/plan-management", plan, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async markReadyDeployment(venueId: string): Promise<CustomerInstanceVenueData> {
        return firstValueFrom(this.http.put<CustomerInstanceVenueData>("/fonzie/customer-instance-venue/" + venueId + "/markReadyDeployment", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async deleteVenue(venueId: string): Promise<void> {
        return firstValueFrom(this.http.delete<void>("/fonzie/customer-instance-venue/" + venueId, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async discontinueVenue(venueId: string): Promise<void> {
        return firstValueFrom(this.http.put<void>("/fonzie/customer-instance-venue/" + venueId + "/discontinue", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async recontinueVenue(venueId: string): Promise<void> {
        return firstValueFrom(this.http.put<void>("/fonzie/customer-instance-venue/" + venueId + "/recontinue", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
